import React from 'react';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

function AuthGuard({ children }) {
  const account = useSelector((state) => state.account);

  if (!account.isLogin) {
    return <Redirect to="/login"/>;
  }

  return children;
}

AuthGuard.propTypes = {
  children: PropTypes.any
};

export default AuthGuard;
